import { combineReducers } from 'redux';

import { alert } from './alert.reducer';
import { user } from './user.reducer';
import { account } from './account/account.reducer';
import { authentication } from './authentication.reducer';
import { element } from './cms/form/element/element.reducer';
import { form } from './cms/form/form.reducer';
import { cms } from './cms/cms.reducer';
import { template } from './cms/template/template.reducer';
import { language } from './system/language/language.reducer';
import { event } from './event/event.reducer';
import { organization } from './organization/organization.reducer';
import { role } from './organization/role.reducer';
import { systemLabels } from './system/systemLabel/systemLabels.reducer';
import { globals } from './global.reducer';
import { confirmation } from "./confirmation/confirmation.reducer"
import { attendee } from "./attendee/attendee.reducer";
import { page } from './cms/page/page.reducer';
import { question } from '../reducers/question/question.reducer';
import { email } from './cms/email/email.reducer';
import { eventLabel } from './event/eventLabel.reducer';
export default combineReducers({
  alert,
  user,
  element,
  authentication,
  form,
  template,
  language,
  event,
  organization,
  role,
  systemLabels,
  globals,
  account,
  cms,
  confirmation,
  attendee,
  page,
  question,
  email,
  eventLabel
})
